import { Client } from "@/Common/Api/Client";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { QuestionnaireFormComponent } from "@/Common/Components/Questionnaire/QuestionnaireFormComponent";
import { TemplateFormRenderer } from "@/Common/Components/Questionnaire/Renderer/TemplateFormRenderer";
import { FormTemplate } from "@/Common/Models/Forms/FormTemplate";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { QuestionnaireIntroductionSection } from "./QuestionnaireIntroductionSection";

interface IQuestionnaireFormAdminViewProps {
    questionnaireId: string;
}

class QuestionnaireFormAdminViewState {
    public formTemplate: FormTemplate;
    public formIntroduction: string;
}

class QuestionnaireFormAdminView extends BaseReactComponent<IQuestionnaireFormAdminViewProps, QuestionnaireFormAdminViewState> {
    private componentId: string = "questionnaire-form-admin-view";

    public componentDidMount(): void {
        this.loadSelectedQuestionnaire(this.props.questionnaireId);
    }

    public componentDidUpdate(prevProps: IQuestionnaireFormAdminViewProps): void {
        if (this.props.questionnaireId != prevProps.questionnaireId) {
            this.loadSelectedQuestionnaire(this.props.questionnaireId);
        }
    }

    public render(): JSX.Element {
        if (!this.state || !this.state.formTemplate)
            return this.renderEmpty();

        let templateFormRenderer = new TemplateFormRenderer([], this.state.formTemplate);

        return (
            <div id={this.componentId} className="questionnaire-admin-view-section">
                <div style={{ borderBottom: "solid 1px #ccc", padding: "15px", backgroundColor: "#F4F6F9" }}>
                    <h3 className="thin-font">{this.state.formTemplate.getComponentName()}</h3>
                </div>

                <div style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "83vh" }}>
                    <div className="questionnaire-section">
                        <h4 className="thin-font">{cacheStore.GetString("SendingParametersLabel")}</h4>
                    </div>
                    <div style={{ padding: "15px 15px 30px 15px" }}>
                        <span style={{ fontWeight: "bold" }}>{cacheStore.GetString("SentWhenLabel")}</span><span>{` ${cacheStore.GetString("MorningOfAppointmentLabel")}`}</span>
                    </div>

                    <QuestionnaireIntroductionSection
                        questionnaireId={this.props.questionnaireId}
                        introduction={this.state.formIntroduction}
                    />

                    <div className="questionnaire-section">
                        <h4 className="thin-font">{cacheStore.GetString("FormLabel")}</h4>
                    </div>
                    <div style={{ paddingLeft: "22px" }}>
                        <QuestionnaireFormComponent
                            componentName={this.state.formTemplate.getComponentName()}
                            answers={[]}
                            templateFormRenderer={templateFormRenderer}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private renderEmpty(): JSX.Element {
        return (
            <div id={this.componentId} className="questionnaire-admin-view-section" />
        );
    }

    private async loadSelectedQuestionnaire(questionnaireId: string): Promise<void> {
        const response = await Client.postAsync<any>(
            ServerOperations.Server.Myle_Admin_Questionnaire_GetQuestionnaireForm,
            {
                QuestionnaireId: questionnaireId
            }
        );

        if (response.isSuccess) {
            this.mutateState(s => {
                s.formTemplate = new FormTemplate(response.data.FormTemplate);
                s.formIntroduction = response.data.Introduction;
            });
        }
        else
            sessionStore.showPopup(response.errors);
    }
}

export { QuestionnaireFormAdminView };
